import axiosInstance from "./axios";

export const fetchServerStats = async () => {
  return axiosInstance.get("/server");
};

export const retryFailedJobs = async () => {
  return axiosInstance.post("/server/queue/retry");
};

export const flushFailedJobs = async () => {
  return axiosInstance.post("/server/queue/flush");
};
